import { IdcardOutlined } from "@ant-design/icons";
import { playerCardCore } from "./core/playerCard";
import { defineWidget } from "../widgetDefinition";
import { playerCardSlots } from "../Slots";
import { NoDuplication, NoInfo } from "../widgetContract";
import { playerCardControlPanel } from "../ControlPanel/playerCard";
import type { PlayerCardComponentSpec } from "../Processing/types";
import { PlayerCardWidget } from "../WidgetComponents/PlayerCardWidget";
import { PlayerCardConfigurator } from "../AddWidgetModal/PlayerCardConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const playerCardDefinition = defineWidget<PlayerCardComponentSpec>({
  ...playerCardCore,
  type: "player_card",
  dynamic: { bindableSections: BINDABLE_SECTIONS.player_card },
  slots: playerCardSlots,
  duplicate: NoDuplication,
  controlPanel: playerCardControlPanel,
  info: NoInfo,
  schema: ["display", "player_id", "requested_options"],
  contractHash: "1pem2b2z6md",

  template: {
    label: "Player Card",
    description: "Show a player's profile, availability, and injuries",
    icon: <IdcardOutlined />,
  },

  defaultLayout: { w: 3, h: 15, minW: 2, minH: 6 }, // vertical card

  gridComponent: ({ id }) => <PlayerCardWidget id={id} />,

  configurator: {
    modalTitle: "Player Card",
    wide: true,
    Component: PlayerCardConfigurator as any,
  },
});
